import { TaggingParams } from '../../components/Tagging/TaggingParams';
import taggingDescriptions from './taggingDescriptions.json';

export const getTaggingInformationScreen = (
  pathName: string,
  pathNameFull?: boolean
): Partial<TaggingParams> => {
  const [screenName] = pathNameFull
    ? [pathName]
    : pathName.split('/').slice(-1);
  const descriptions = JSON.parse(JSON.stringify(taggingDescriptions));
  return (
    descriptions[screenName] ?? {
      screenName: '',
      itemDescription: '',
      commerceScreenName: ''
    }
  );
};
